<app-separator name="Diseño preestablecido"></app-separator>
<br><br>
<div class="container text-center">
    <div class="row justify-content-center" >
        <div class="col" (click)="onSelect(template)" *ngFor="let template of templates">
            <img class="w-100 border rounded" [src]="template.banner">
        </div>
    </div>
    <br>
</div>